const REGEX_VARIABLES = /\{\{(.*?)\}\}/g

const extractVariables = body => {
  if (body) return [...body.matchAll(REGEX_VARIABLES)].map(match => match[1])
  return undefined
}

export default extractVariables
